var _path, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRespIllustrationEtudeSection5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 228,
    viewBox: "0 0 303 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 202.5C120 216.583 131.417 228 145.5 228C159.583 228 171 216.583 171 202.5L171 25.5C171 11.4167 159.583 0 145.5 0C131.417 0 120 11.4167 120 25.5L120 202.5Z",
    fill: "#005B7F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46.9065,
    height: 233.793,
    rx: 23.4532,
    transform: "matrix(-0.00222545 -0.999997 -0.999997 0.00222545 233.897 130.554)",
    fill: "#E29578"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 38.5752,
    height: 233.793,
    rx: 19.2876,
    transform: "matrix(-0.00222545 -0.999997 -0.999997 0.00222545 254.148 98.0674)",
    fill: "#FFDDD2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 30.6786,
    height: 233.793,
    rx: 15.3393,
    transform: "matrix(-0.00222545 -0.999997 -0.999997 0.00222545 282.729 116.393)",
    fill: "#E8F8FE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 31.1282,
    height: 233.793,
    rx: 15.5641,
    transform: "matrix(-0.00222545 -0.999997 -0.999997 0.00222545 303 152.212)",
    fill: "#679ACB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRespIllustrationEtudeSection5);
export default __webpack_public_path__ + "static/media/Resp_IllustrationETUDE_section5.87346b1f6537fb190cfc7762b03d62d5.svg";
export { ForwardRef as ReactComponent };